import { createReducer } from 'redux-act'

import FiltersState, { InitializeFiltersPayload, FilterClickPayload } from './types'
import {
    initializeFilters,
    setFiltersConfiguration,
    commitFiltersConfiguration,
    revertFiltersConfiguration,
    setFiltersError,
    setLoading,
    setBlocking,
    setCurrentOpenedFilterModal,
    setLastDataPathEncoded,
    openCancellationPolicyModal,
    closeCancellationPolicyModal,
} from './actions'
import { FilterModalType, FilterType } from '../../components/app-components/filter-sort-section/types'
import { getRelativeURL } from '../../utils/encoding-utils'
import initialState from './state'

const _initializeFilters = (_state: FiltersState, payload: InitializeFiltersPayload): FiltersState => ({
    ..._state,
    filtersConfigurationResponse: payload.config,
    committedFiltersConfigurationResponse: payload.config,
    regionNodeId: payload.regionNodeId,
    spaMode: payload.spaMode,
    lastDataPathEncoded: getRelativeURL(payload.config.encodedLink),
    error: null,
})

const _setFiltersConfiguration = (state: FiltersState, payload: FilterClickPayload): FiltersState => ({
    ...state,
    filtersConfigurationResponse: payload.config,
    committedFiltersConfigurationResponse: payload.shouldCommit
        ? payload.config
        : state.committedFiltersConfigurationResponse,
})

const _commitFiltersConfiguration = (state: FiltersState): FiltersState => ({
    ...state,
    committedFiltersConfigurationResponse: state.filtersConfigurationResponse,
})

const _revertFiltersConfiguration = (state: FiltersState): FiltersState => ({
    ...state,
    filtersConfigurationResponse: state.committedFiltersConfigurationResponse,
})

const _setFiltersError = (state: FiltersState, payload: Error | null): FiltersState => ({
    ...state,
    error: payload,
})

const _setLoading = (state: FiltersState, payload: boolean): FiltersState => ({
    ...state,
    isLoading: payload,
})

const _setBlocking = (state: FiltersState, payload: boolean): FiltersState => ({
    ...state,
    isBlocking: payload,
})

const _setCurrentOpenedFilterModal = (state: FiltersState, payload: FilterModalType | FilterType): FiltersState => ({
    ...state,
    currentOpenedFilterModal: payload,
})

const _setLastDataPathEncoded = (state: FiltersState, payload: string): FiltersState => ({
    ...state,
    lastDataPathEncoded: payload,
})

const _openCancellationPolicyModal = (state: FiltersState): FiltersState => ({
    ...state,
    previousFilterModal: state.currentOpenedFilterModal,
    currentOpenedFilterModal:
        state.currentOpenedFilterModal !== FilterModalType.NONE ? FilterModalType.NONE : state.currentOpenedFilterModal,
    isCancellationPolicyModalOpen: true,
})

const _closeCancellationPolicyModal = (state: FiltersState): FiltersState => ({
    ...state,
    isCancellationPolicyModalOpen: false,
    currentOpenedFilterModal: state.previousFilterModal,
    previousFilterModal: FilterModalType.NONE,
})

const reducer = createReducer<FiltersState>(on => {
    on(initializeFilters, _initializeFilters)
    on(setFiltersConfiguration, _setFiltersConfiguration)
    on(commitFiltersConfiguration, _commitFiltersConfiguration)
    on(revertFiltersConfiguration, _revertFiltersConfiguration)
    on(setFiltersError, _setFiltersError)
    on(setLoading, _setLoading)
    on(setBlocking, _setBlocking)
    on(setCurrentOpenedFilterModal, _setCurrentOpenedFilterModal)
    on(setLastDataPathEncoded, _setLastDataPathEncoded)
    on(openCancellationPolicyModal, _openCancellationPolicyModal)
    on(closeCancellationPolicyModal, _closeCancellationPolicyModal)
}, initialState)

export default reducer
